import styled from 'styled-components';
import { TABLET_WIDTH } from 'constants/breakPoints';

export const NarrativeStyled = styled.div`
  &.no_transition {
    .step_content {
      transition: none !important;
    }
  }

  .overflow_step {
    height: calc(100vh - 12rem);
    overflow: hidden;
  }
`;

export const StepContent = styled.div`
  height: 100%;
  transition: all 0.6s ease;
  overflow: auto;
  &.is_swiping {
    transition: none;
  }
`;

export const Buttons = styled.div`
  display: none;
  position: relative;
  @media (min-width: ${TABLET_WIDTH}px) {
    display: block;
  }

  > div {
    padding: 10px 20px;
    position: absolute;
    font-size: 14px;
    color: #fff;
    border: 1px solid #fff;
    border-radius: 40px;
    cursor: pointer;
    min-width: 120px;
    text-align: center;

    &:hover {
      background-color: #fff;
      color: ${props => props.color};
      transition: background-color 0.2s linear;
    }
  }

  .prev_button {
    left: 20px;

    i {
      margin-right: 5px;
    }
  }

  .next_button {
    right: 20px;

    i {
      margin-left: 5px;
    }
  }
`;

export const LoadingWrapper = styled.div`
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/Narrative/components/styles.js